import React from 'react';
import './App.css';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { BrandsSection } from './components/BrandsSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';

function App() {
  return (
    <div className="App" dir="rtl">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <BrandsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;